<template>
<div class="form-part">
  <div class="row">
    <div class="col-12 text-center">
      <h1>LBT Archive</h1>
      <p id="useful-links">
        <strong>
          <a href="#" @click="showHelpModal">Useful links</a>
        </strong>
      </p>
    </div>
  </div>

  <!-- Banner giallo
  <div class="alerts">
    <b-alert show variant="warning">
      <h4 class="alert-heading">Scheduled Testing in Progress</h4>
      <p>
         The archive is currently undergoing scheduled testing. While systems are operational, you may experience brief, temporary downtimes. Thank you for your patience.
      </p>
    </b-alert>
  </div>
  -->

  <!-- Banner rosso
  <div class="alerts">
    <b-alert show variant="danger">
      <h4 class="alert-heading">Important notice!</h4>
      <p>
        The archive is currently under maintenance and some features may be temporarily unavailable. We apologize for the inconvenience.
      </p>
    </b-alert>
  </div>
  -->

  <div class="row">
    <div class="col-12">
      <NameResolver />
    </div>
  </div>
  <div class="row">
    <div class="col-2 label-right mt-1">
      <label>File name</label>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.main_file_name" class="file_name_input"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <b-form-checkbox v-model="fields.main_date_obs_sel" class="mt-1">Observation date</b-form-checkbox>
    </div>
    <div class="col-1 label-right" v-if="!fields.main_single_night">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3" v-if="!fields.main_single_night">
      <b-input-group>
        <b-form-input v-model="fields.main_date_obs_min" placeholder="yyyy-MM-dd HH:mm"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.main_date_obs_min" format="YYYY-MM-DD HH:mm" :no-label="true" :only-date="false" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.main_date_obs_min">{{fieldErrors.main_date_obs_min}}</span>
    </div>
    <div class="col-1 label-right" v-if="!fields.main_single_night">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3" v-if="!fields.main_single_night">
      <b-input-group>
        <b-form-input v-model="fields.main_date_obs_max" placeholder="yyyy-MM-dd HH:mm"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.main_date_obs_max" format="YYYY-MM-DD HH:mm" :no-label="true" :only-date="false" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.main_date_obs_max">{{fieldErrors.main_date_obs_max}}</span>
    </div>
    <div class="col-3" v-if="fields.main_single_night">
      <b-input-group>
        <b-form-input v-model="fields.main_date_obs" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.main_date_obs" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.main_date_obs">{{fieldErrors.main_date_obs}}</span>
    </div>
    <div class="col-2 label-left">
      <b-form-checkbox v-model="singleNight" class="mt-1 ml-3">Single night</b-form-checkbox>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.main_exptime_sel" class="mt-1">Exposure time (s)</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.main_exptime_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.main_exptime_min">{{fieldErrors.main_exptime_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.main_exptime_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.main_exptime_max">{{fieldErrors.main_exptime_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.main_flt_id_sel" class="mt-1">Filter</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.main_flt_id" class="fit-width"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.main_instrument_sel" class="mt-1">Instrum.</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.main_instrument" class="fit-width">
        <option :value="null">Select...</option>
        <option>LBC</option>
        <option value="LUC">LUCI</option>
        <option>IRTC</option>
        <option>MODS</option>
        <option value="PIS">PISCES</option>
        <option value="lmircam">LBTI/LMIRCam</option>
        <option value="nomic">LBTI/NOMIC</option>
        <option>PEPSI</option>
        <option>SHARK-VIS</option>
        <option>SHARK-NIR</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.main_object_sel" class="mt-1">Object</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.main_object" class="fit-width"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.main_imagetyp_sel" class="mt-1">Obs. Type</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.main_imagetyp" class="fit-width"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.main_piname_sel" class="mt-1">PI name</b-form-checkbox>
        </div>
        <div class="col-8">
          <b-form-input v-model="fields.main_piname" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row ml-3">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.main_partner_sel" class="mt-1">Partner</b-form-checkbox>
        </div>
        <div class="col-8">
          <b-form-select v-model="fields.main_partner" class="fit-width">
            <option :value="null">Select...</option>
            <option>AZ</option>
            <option>CALIBRATION</option>
            <option>COMMISSIONING</option>
            <option>COMMON</option>
            <option>INAF</option>
            <option>IRTC</option>
            <option>ITALY</option>
            <option>LBC</option>
            <option>LBTB</option>
            <option>LBTO</option>
            <option>LBTSDT</option>
            <option>NOPARTNER</option>
            <option value="OSU">OSURC</option>
            <option>TSIP</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row ml-3">
        <div class="col-4">
          <b-form-checkbox v-model="fields.main_short_program_sel" class="mt-1">Program</b-form-checkbox>
        </div>
        <div class="col-8">
          <b-form-input v-model="fields.main_short_program" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="help-modal" hide-footer title="Useful links">
    <div>
      <ul>
        <li><a href="#" @click="showHelpSidebar">Generic portal usage</a> (open Help sidebar)</li>
        <li class="mt-2">
          Accessing private files:
          <ul>
            <li><a href="https://sso.ia2.inaf.it/home/" target="_blank">Information about login</a></li>
            <li><a href="https://sso.ia2.inaf.it/gms" target="_blank">GMS (groups management)</a></li>
            <li><a href="https://sso.ia2.inaf.it/gms/help/index.html" target="_blank">GMS help page</a></li>
          </ul>
        </li>
      </ul>
    </div>
    <b-button class="mt-3 float-right" @click="hideHelpModal">Close</b-button>
  </b-modal>
</div>
</template>

<script>
import NameResolver from '../../NameResolver.vue';
import Vue from 'vue';

export default {
  name: 'Main',
  components: {
    NameResolver
  },
  computed: {
    fields() {
      return this.$store.state.searchForm.fields;
    },
    fieldErrors() {
      return this.$store.state.searchForm.fieldErrors;
    },
    singleNight: {
      get() {
        return this.$store.state.searchForm.fields.main_single_night;
      },
      set(newValue) {
        Vue.set(this.$store.state.searchForm.fields, "main_single_night", newValue);
        // Reset opposite fields
        if (newValue) {
          this.fields.main_date_obs_min = '';
          this.fields.main_date_obs_max = '';
        } else {
          this.fields.main_date_obs = '';
        }
      }
    }
  },
  methods: {
    showHelpModal() {
      this.$refs['help-modal'].show();
    },
    hideHelpModal() {
      this.$refs['help-modal'].hide();
    },
    showHelpSidebar() {
      this.hideHelpModal();
      this.$store.commit('setHelpMenuOpened', true);
    }
  }
}
</script>

<style>
h1 {
  font-size: 2.1rem;
}

#useful-links {
  font-size: 15px;
}
</style>
